import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import RankingsIndexArea from 'buyside/components/presentation/RankingsIndexPage/RankingsIndexArea';
import RankingsIndexAreaQueries from './RankingsIndexAreaQueriesContainer';
import { IndexAreaLoadingSpinner } from 'buyside/components/presentation/IndexPage/IndexPage';

const RankingsIndexAreaContainer = ({ category, isPublic }) => {
  return (
    <ErrorBoundary pageName="Ranking Index Area">
      <RankingsIndexAreaQueries category={category} isPublic={isPublic}>
        {({ loading, data }) => {
          return (
            <IndexAreaLoadingSpinner loading={loading} data={data}>
              <RankingsIndexArea
                rankingDate={data.rankingDate}
                requiredSubmissionAmount={data.requiredSubmissionAmount}
                canViewIdeaFilterDetails={data.canViewIdeaFilterDetails}
                canViewUserDetails={data.canViewUserDetails}
                showIdeasLink={data.showIdeasLink}
                category={category}
                isPublic={isPublic}
                ranks={data.ranks}
                hasNextPage={data.hasNextPage}
                fetchNextPage={data.fetchNextPage}
              />
            </IndexAreaLoadingSpinner>
          );
        }}
      </RankingsIndexAreaQueries>
    </ErrorBoundary>
  );
};

export default RankingsIndexAreaContainer;
